import ArrowRight from 'components/DynamicIcon/ArrowRight';
import ScoreLine from 'components/Molecules/LoyaltyStore/ScoreLine';
import TablePointModal from 'components/Molecules/LoyaltyStore/TablePointModal';
import TermAndPoliciesModal from 'components/Molecules/LoyaltyStore/TermAndPoliciesModal';
import { RankCodeServer } from 'constants/index';
import { checkMemberType, getAssetWithRank } from 'helpers/loyaltyStore';
import React, { useEffect, useState } from 'react';
import { formatTimeString, format_curency } from 'utils';
import { configPoint } from './data';

const ScoreLevel = ({ loyaltyData }) => {
  const assetFolder = '/assets/images/loyalty/pc/rank';

  const [assetData, setAssetData] = useState({
    urlBackground: ``,
    bigIcon: `${assetFolder}/big_icon/un_rank.png`,
    lineColor: '#262626',
    mainColor: '#434343',
    textDate: '#262626',
    textPoint: '#7b7b7b',
    textRankProgress: '#7b7b7b',
    specialIcon: ``,
    lastRankChangedTime: new Date().toISOString(),
    rankCode: RankCodeServer.MEMBER,
    rankName: 'Chưa xếp hạng',
    nextRankName: 'Silver',
    pointToNextTempRank: 20000000,
    point: 0,
    coin: 0,
  });
  const [isOpenSearchPoint, setIsOpenSearchPoint] = useState(false);
  const [isOpenTermAndPolicies, setIsOpenTermAndPolicies] = useState(false);
  const [isShowScoreLevel, setIsShowScoreLevel] = useState(true);

  const { date, month, year } = formatTimeString(assetData.lastRankChangedTime);

  // 1 score = 1000vnđ
  const listRank = [
    {
      node: (
        <div className='w-5 mt-[17px]'>
          <div
            className='p-0.5 rounded-full'
            style={{
              width: 'fit-content',
              backgroundColor: `${assetData.rankCode === RankCodeServer.DIAMOND ? '#000' : '#fff'}`,
            }}
          >
            <img className='w-fit' src={`${assetFolder}/icon/silver.png`} />
          </div>
          <p
            className='text-12px mt-2 text-center whitespace-nowrap'
            style={{ transform: 'translateX(-100%)', color: `${assetData.textRankProgress}` }}
          >
            Silver: 20tr
          </p>
        </div>
      ),
      mount: configPoint.silver,
      rankLabel: 'Silver',
    },
    {
      node: (
        <div className='w-5 mt-[17px]'>
          <div
            className='p-0.5 rounded-full'
            style={{
              width: 'fit-content',
              backgroundColor: `${assetData.rankCode === RankCodeServer.DIAMOND ? '#000' : '#fff'}`,
            }}
          >
            <img className='w-fit' src={`${assetFolder}/icon/gold.png`} />
          </div>
          <p
            className='text-12px mt-2 text-center whitespace-nowrap'
            style={{ transform: 'translateX(-20%)', color: `${assetData.textRankProgress}` }}
          >
            Gold: 50tr
          </p>
        </div>
      ),
      mount: configPoint.gold,
      rankLabel: 'Gold',
    },
    {
      node: (
        <div className='w-5 mt-[17px]'>
          <div
            className='p-0.5 rounded-full'
            style={{
              width: 'fit-content',
              backgroundColor: `${assetData.rankCode === RankCodeServer.DIAMOND ? '#000' : '#fff'}`,
            }}
          >
            <img className='w-fit' src={`${assetFolder}/icon/platinum.png`} />
          </div>
          <p
            className='text-12px mt-2 text-center whitespace-nowrap'
            style={{ transform: 'translateX(-100%)', color: `${assetData.textRankProgress}` }}
          >
            Platinum: 150tr
          </p>
        </div>
      ),
      mount: configPoint.platinum,
      rankLabel: 'Platinum',
    },
    {
      node: (
        <div className='w-5 mt-[17px]'>
          <div
            className='p-0.5 rounded-full'
            style={{
              width: 'fit-content',
              backgroundColor: `${assetData.rankCode === RankCodeServer.DIAMOND ? '#000' : '#fff'}`,
            }}
          >
            <img src={assetData.specialIcon || `${assetFolder}/icon/diamond_1.png`} />
          </div>
          <div
            className='text-12px mt-2 text-center whitespace-nowrap'
            style={{ transform: 'translateX(-100%)', color: `${assetData.textRankProgress}` }}
          >
            Diamond: 300tr
          </div>
        </div>
      ),
      mount: configPoint.diamond,
      rankLabel: 'Diamond',
    },
  ];

  const handleOpenTermAndPolicies = () => {
    if (assetData.rankCode === RankCodeServer.SILVERPLUS) {
      // not allow silver banca open
    } else {
      setIsOpenTermAndPolicies(true);
    }
  };

  useEffect(() => {
    if (loyaltyData.obj?.memberLoyaltyInfo) {
      const rankCode = loyaltyData.obj.memberLoyaltyInfo.rank.name.toLowerCase();
      const nextRankCode = loyaltyData.obj.memberLoyaltyInfo.nextRank.name.toLowerCase();

      const rankName = checkMemberType(rankCode);
      const nextRankName = checkMemberType(nextRankCode);
      const assetRank = getAssetWithRank(assetFolder, rankCode);

      let point = loyaltyData.obj.memberLoyaltyInfo.point;
      const coin = loyaltyData.obj.memberLoyaltyInfo.coin;

      if (rankCode === RankCodeServer.PREMIERCLUBHSBC) {
        setIsShowScoreLevel(false);
      }
      setAssetData((pre) => {
        return {
          ...pre,
          lastRankChangedTime: loyaltyData.obj.memberLoyaltyInfo.lastRankChangedTime,
          rankCode: rankCode,
          rankName: rankName,
          point,
          coin,
          pointToNextTempRank: loyaltyData.obj.memberLoyaltyInfo.pointToNextTempRank,
          nextRankName: nextRankName,
          ...assetRank,
        };
      });
    }
  }, [loyaltyData]);

  return (
    <div className='p-0'>
      <div
        className='flex flex-wrap md:flex-nowrap justify-center lg:justify-start items-center mb-4 w-full h-250px bg-white lg:h-150px py-6 px-2 lg:px-6 lg:rounded-lg'
        style={{
          backgroundImage: `url(${assetData.urlBackground})`,
          backgroundSize: 'cover',
          backgroundRepeat: 'no-repeat',
          backgroundPosition: 'center',
        }}
      >
        <div className='flex items-center relative'>
          <img src={assetData.bigIcon} alt='' />
          <div className='pl-2'>
            <h3
              className='text-xl'
              style={{
                color: `${assetData.mainColor}`,
              }}
            >
              <span className='capitalize'>{assetData.rankName} </span>
            </h3>
            <p
              className="font-light text-14px whitespace-nowrap font-['RobotoMedium']"
              style={{
                color: `${assetData.textDate}`,
              }}
            >
              Ngày phân hạng: {date}/{month}/{year}
            </p>
          </div>
          <div className='h-full bg-979797 mx-4' style={{ height: '30px', width: '1px' }}></div>
          <div className='cursor-pointer' onClick={() => setIsOpenSearchPoint(true)}>
            <p
              className='text-12px'
              style={{
                color: `${assetData.textPoint}`,
              }}
            >
              Điểm đổi quà
            </p>
            <div className='flex items-center'>
              <p
                className='text-20px'
                style={{
                  color: `${assetData.mainColor}`,
                  minWidth: '80px',
                }}
              >
                {format_curency(assetData.coin)}
              </p>
              <ArrowRight fill={assetData.mainColor} />
            </div>
          </div>
        </div>
        {isShowScoreLevel && (
          <div className='hidden sm:block h-24 bg-EEEEEE mx-5 ml-10' style={{ width: '1px' }}></div>
        )}
        {isShowScoreLevel && (
          <div className='w-full md:mr-6 pr-[30px]' onClick={handleOpenTermAndPolicies}>
            <ScoreLine listRank={listRank} assetData={assetData} />
          </div>
        )}
      </div>
      <TermAndPoliciesModal
        assetData={assetData}
        listRank={listRank}
        opened={isOpenTermAndPolicies}
        handleOpened={setIsOpenTermAndPolicies}
      />
      <TablePointModal
        point={assetData.coin}
        opened={isOpenSearchPoint}
        handleOpened={setIsOpenSearchPoint}
      />
    </div>
  );
};

export default ScoreLevel;
